<template>
  <a class="py-2 mr-4 text-slate-600 hover:text-slate-900 flex items-center border-b-2" :class="{
    'border-slate-900': isActive,
    'grayscale border-transparent': !isActive,
  }" href="#" @click="action">
    <template v-if="isIcon">
      <span class="text-green-500 inline mr-1" v-if="iconName === 'clock'">
        <ClockIcon class="w-5 h-5" />
      </span>

      <span class="text-green-500 inline mr-1" v-if="iconName === 'success'">
        <CheckCircleIcon class="w-5 h-5" />
      </span>

      <span class="text-yellow-600 inline mr-1" v-if="iconName === 'warning'">
        <ShieldExclamationIcon class="w-5 h-5" />
      </span>
    </template>

    {{ title }}
  </a>
</template>

<script setup>
import { ShieldExclamationIcon, CheckCircleIcon, ClockIcon } from '@heroicons/vue/outline';

const emit = defineEmits(['action']);
defineProps({
  title: String,
  isActive: Boolean,
  isIcon: Boolean,
  iconName: String,
});

const action = function () {
  emit('action');
};
</script>
